import type { PolylineDataT } from '../../../types';
export const interpolatePolyline = (initialLine: PolylineDataT, finalLine: PolylineDataT, interpolationFactor: number): PolylineDataT => {
  // consider max length of the points in both the lines
  // TODO: revisit if there are any better ways available - TOPENG-25750
  const numPoints = Math.max(initialLine.points.length, finalLine.points.length);
  const interpolatedPoints: number[][] = [];
  for (let i = 0; i < numPoints; i++) {
    //take last point when the index is greater than the length of the points
    const initialPoint = initialLine.points[Math.min(i, initialLine.points.length - 1)];
    const finalPoint = finalLine.points[Math.min(i, finalLine.points.length - 1)];
    interpolatedPoints.push([
    // @ts-expect-error todo(ts-migration) TS18048 'initialPoint' is possibly 'undefined'.
    initialPoint[0] + (finalPoint[0] - initialPoint[0]) * interpolationFactor,
    // @ts-expect-error todo(ts-migration) TS18048 'initialPoint' is possibly 'undefined'.
    initialPoint[1] + (finalPoint[1] - initialPoint[1]) * interpolationFactor]);
  }
  // @ts-expect-error todo(ts-migration) TS2322 Type 'number[][]' is not assignable to type '[number, number][]'.
  return {
    points: interpolatedPoints
  };
};

// Helper function to calculate distance between two points
const getDistance = (point1: [number, number], point2: [number, number]) => {
  const dx = point2[0] - point1[0];
  const dy = point2[1] - point1[1];
  return Math.sqrt(dx * dx + dy * dy);
};

// Helper function to find the closest non-overlapping point, recursively traversing backwards until the two points are more than minDistance apart
const closestNonOverlappingPoint = (points: [number, number][], index: number, minDistance: number) => {
  let closestPointIndex = index;
  for (; closestPointIndex >= 0; closestPointIndex--) {
    // @ts-expect-error todo(ts-migration) TS2345 Argument of type '[number, number] | undefined' is not assignable to parameter of type '[number, number]'.
    const distance = getDistance(points[index], points[closestPointIndex]);
    if (distance >= minDistance) {
      break;
    }
  }
  if (closestPointIndex < 0) {
    closestPointIndex = 0;
  }
  return closestPointIndex;
};
export const getArrowTransformationProperties = (points: [number, number][]) => {
  const getMidpointAndAngle = (points: [number, number][]) => {
    const totalPoints = points.length;
    if (totalPoints < 2) {
      return null;
    }

    // Find the last two points that are at least 5 pixels apart
    const MIN_DISTANCE = 5;
    const lastPointIndex = totalPoints - 1;
    const _closestNonOverlappingPoint = closestNonOverlappingPoint(points, lastPointIndex, MIN_DISTANCE);

    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    const dx = points[lastPointIndex][0] - points[_closestNonOverlappingPoint][0];
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    const dy = points[lastPointIndex][1] - points[_closestNonOverlappingPoint][1];
    const angle = Math.atan2(dy, dx) * 180 / Math.PI;
    // @ts-expect-error todo(ts-migration) TS2532 Object is possibly 'undefined'.
    return {
      x: points[lastPointIndex][0],
      y: points[lastPointIndex][1],
      angle
    };
  };
  const midpointData = getMidpointAndAngle(points);
  const transform = midpointData ? `translate(${midpointData.x}, ${midpointData.y}) rotate(${midpointData.angle})` : '';
  return transform;
};